import { deleteCookie, getCookie, setCookie } from 'cookies-next';
import { DomainConfigManager } from './domain-config-manager';

export function readCookie(name: string): string | undefined {
  return getCookie(name);
}

export async function writeCookie({
  domain,
  expiresAt,
  name,
  value,
}: {
  name: string;
  value: string;
  domain: string;
  expiresAt: number;
}) {
  // strip port if present (e.g. localhost:3000) and avoid setting domain for
  // localhost or raw IPs since cookie libraries reject those values
  const host = domain ? domain.split(':')[0] : '';

  const cookieOptions: Record<string, unknown> = {
    sameSite: 'lax',
    expires: new Date(expiresAt),
    priority: 'medium',
    secure: process.env.NODE_ENV !== 'development',
  };

  const isIp = /^\d+\.\d+\.\d+\.\d+$/.test(host);
  if (host && host !== 'localhost' && !isIp) {
    cookieOptions.domain = `.${host}`;
  }

  setCookie(name, value, cookieOptions);
}

export async function clearCookie(name: string) {
  const domain = await DomainConfigManager.getDomain();
  const host = domain ? domain.split(':')[0] : '';
  const deleteOptions: Record<string, unknown> = { sameSite: 'lax' };

  const isIp = /^\d+\.\d+\.\d+\.\d+$/.test(host);
  if (host && host !== 'localhost' && !isIp) {
    deleteOptions.domain = `.${host}`;
  }

  deleteCookie(name, deleteOptions);
}
